import pacmanBanner from "./2d/pacman-banner";

const pacmanCanvas = document.querySelectorAll(".pacman_banner");

pacmanCanvas.forEach(canvas => {
    pacmanBanner(canvas, "yellow");
});
